import { addSeconds } from 'date-fns/esm'

export const getDateFromDuration = (duration: number, date: Date = new Date()): Date => {
  const midnightDate: Date = new Date(date)
  midnightDate.setHours(0, 0, 0, 0)
  return addSeconds(midnightDate, duration)
}
